module.exports = __webpack_public_path__ + "img/stb-pay.f44d554c.png";